var _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlidernext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_0_350",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.800049 0H40V39.2H0.800049V0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3808 26.0486C16.0171 26.4643 16.0592 27.096 16.4749 27.4597C16.8905 27.8234 17.5223 27.7813 17.886 27.3656L16.3808 26.0486ZM23.4584 19.4786L24.211 20.1371C24.5409 19.76 24.5409 19.1971 24.211 18.8201L23.4584 19.4786ZM17.886 11.5915C17.5223 11.1758 16.8905 11.1337 16.4749 11.4974C16.0592 11.8611 16.0171 12.4929 16.3808 12.9085L17.886 11.5915ZM17.886 27.3656L24.211 20.1371L22.7058 18.8201L16.3808 26.0486L17.886 27.3656ZM24.211 18.8201L17.886 11.5915L16.3808 12.9085L22.7058 20.1371L24.211 18.8201ZM0.800049 0V-2H-1.19995V0H0.800049ZM40 0H42V-2H40V0ZM40 39.2V41.2H42V39.2H40ZM0.800049 39.2H-1.19995V41.2H0.800049V39.2ZM0.800049 2H40V-2H0.800049V2ZM38 0V39.2H42V0H38ZM40 37.2H0.800049V41.2H40V37.2ZM2.80005 39.2V0H-1.19995V39.2H2.80005Z",
    fill: "#EAB78D",
    mask: "url(#path-1-inside-1_0_350)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlidernext);
export default __webpack_public_path__ + "static/media/slidernext.d487c89048368cdc32dbb25016fecb44.svg";
export { ForwardRef as ReactComponent };